import { useRef, useEffect, useCallback } from 'react';
import { Send } from 'lucide-react';

export default function ChatInput({ input, onInputChange, onSend, isStreaming, placeholder, sendLabel, inputRef }) {
  const textareaRef = useRef(null);
  const setTextareaRef = useCallback((node) => {
    textareaRef.current = node;
    if (inputRef) inputRef.current = node;
  }, [inputRef]);

  // Auto-resize textarea to fit content (up to ~5 lines)
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    const maxH = 140;
    const h = Math.min(el.scrollHeight, maxH);
    el.style.height = h + 'px';
    el.style.overflowY = el.scrollHeight > maxH ? 'auto' : 'hidden';
  }, [input]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="p-3 md:p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex gap-3 p-3 rounded-xl items-end bg-light-input border border-light-border dark:bg-thinking-primary dark:border-0">
          {/* 回答生成中でも次の下書きは入力できるようにする。 */}
          <textarea
            ref={setTextareaRef}
            value={input}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            disabled={false}
            rows={1}
            className={`flex-1 px-4 py-3 rounded-lg outline-none focus:ring-2 focus:ring-thinking-primary/30 resize-none
                bg-white text-light-text placeholder-light-muted border border-light-border
                dark:bg-transparent dark:text-accent-text dark:placeholder-accent-text dark:border-glass
                ${isStreaming ? 'opacity-50' : ''}`}
          />
          <button
            onClick={onSend}
            disabled={!input.trim() || isStreaming}
            className={`px-6 py-[11.5px] mb-[4px] rounded-lg transition flex items-center justify-center gap-2 flex-shrink-0 ${
              !input.trim() || isStreaming
              ? 'bg-light-input text-light-muted cursor-not-allowed dark:bg-thinking-primary dark:text-[#F5EFE6]/60'
              : 'bg-thinking-primary text-accent-text hover:opacity-90 dark:bg-thinking-secondary dark:text-primary dark:hover:bg-main dark:hover:opacity-100'
              }`}
          >
            <Send size={18} />
            <span className="hidden sm:inline">{sendLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
